import { Injectable } from '@angular/core';
import { FormSaveStrategy } from './form-save-strategy.abstract';
import { map, Observable, ReplaySubject, Subject, takeUntil, tap } from 'rxjs';
import { AddressDto } from '../../../../api/v1/models/address-dto';
import { CoordinatesDto } from '../../../../api/v1/models/coordinates-dto';

@Injectable()
export class ConfirmFormStrategy extends FormSaveStrategy {
  private destroy$ = new Subject<void>();

  private _confirmedData$: ReplaySubject<{outletId: number, isUserChoose: boolean}> = new ReplaySubject<{outletId: number, isUserChoose: boolean}>(1);

  private _addressSubmitSubj$: Subject<unknown> = new Subject<unknown>();

  override setActiveOutlet(outletId: number, isUserChoose: boolean) {
    this._confirmedData$.next({outletId, isUserChoose});
  }

  get debounceTimeout(): number {return 0;}

  confirmSaveOutlet(){
    this._confirmedData$.asObservable().pipe(
      takeUntil(this.destroy$)
    ).subscribe(({outletId, isUserChoose}) => {
      this.configRepository.setActiveOutlet(outletId);
      if(isUserChoose){
        this.configRepository.setUserChooseState(true);
      }
    })
  }

  override setDeliveryAddress(address: AddressDto, coordinates: CoordinatesDto | null = null): Observable<AddressDto> {
    return this._addressSubmitSubj$.asObservable().pipe(
      tap(() => {
        this.sessionRepository.setDeliveryAddress(address, coordinates)
      }),
      map(() => address),
    )
  }

  confirmSaveDeliveryAddress(){
    this._addressSubmitSubj$.next(null);
  }

  /*
  * Срабатывает на onDestroy компонента, к которому привязан сервис
  * */
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
